/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

import { FauxMenuViewModel, FauxMenuShape, FauxMenuSize } from 'src/types/view-models/faux-menu.view.model';

import { ReactComponent as ArrowDownIcon } from './dls-glyph-down.svg';

// stylesheets
import styles from './FauxMenu.module.scss';

export default class BaseFauxMenu extends Component<FauxMenuViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className={this.getClasses()} onClick={this.props.onClick} id={this.props.id}>
                <span className="text">{this.props.children}</span>
                <ArrowDownIcon className="arrow" />
            </div>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        switch (this.props.shape) {
            case FauxMenuShape.DEFAULT:
                switch (this.props.size) {
                    case FauxMenuSize.DEFAULT:
                        classes.push(styles.fauxMenuDefault);
                        break;
                    case FauxMenuSize.MINI:
                        classes.push(styles.fauxMenuMiniDefault);
                        break;
                }
                break;
            case FauxMenuShape.ROUNDED:
                switch (this.props.size) {
                    case FauxMenuSize.DEFAULT:
                        classes.push(styles.fauxMenuRounded);
                        break;
                    case FauxMenuSize.MINI:
                        classes.push(styles.fauxMenuMiniRounded);
                        break;
                }
                break;
        }

        if (this.props.fullWidth) {
            classes.push(styles.fauxMenuFullWidth);
        } else {
            classes.push(styles.fauxMenuDefaultWidth);
        }

        if (this.props.disabled) {
            classes.push('disabled');
        }

        return classes.join(' ');
    }
}
